import { createValidation } from '../../utils/validation';
import deviationConfig from './deviationConfig';

// Create validation factory for Deviation entity
const createDeviationValidation = () => {
  return createValidation(deviationConfig.fields);
};

// Export both the factory and a default instance
export const validateDeviationData = createDeviationValidation();
export const createDeviationValidationSchema = createDeviationValidation;
export default createDeviationValidation;
